import { useContext } from 'react';
import LoginForm from '../components/loginForm/loginForm';
import { AppContext } from '../context/context';

const Auth = ({ children }) => {
    const { isLogin } = useContext(AppContext);

    return (
        <>{isLogin ? <>{children}</> : <LoginForm />}</>
    )
}

export default Auth;
